var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.5727539,21.6894531C43.7797852,12.3056641,34.3066406,6,24,6S4.2202148,12.3056641,0.4272461,21.6894531 C0.144043,22.390625,0,23.1679688,0,24s0.144043,1.609375,0.4272461,2.3105469C4.2202148,35.6943359,13.6933594,42,24,42 s19.7797852-6.3056641,23.5727539-15.6894531C47.855957,25.609375,48,24.8320312,48,24S47.855957,22.390625,47.5727539,21.6894531z  M45.7182617,25.5605469C42.2280273,34.1972656,33.5,40,24,40S5.7719727,34.1972656,2.2817383,25.5605469 C2.0947266,25.0986328,2,24.5732422,2,24s0.0947266-1.0986328,0.2817383-1.5605469C5.7719727,13.8027344,14.5,8,24,8 s18.2280273,5.8027344,21.7182617,14.4394531C45.9052734,22.9013672,46,23.4267578,46,24 S45.9052734,25.0986328,45.7182617,25.5605469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,14c-5.5141602,0-10,4.4863281-10,10s4.4858398,10,10,10s10-4.4863281,10-10S29.5141602,14,24,14z M24,32 c-4.4111328,0-8-3.5888672-8-8s3.5888672-8,8-8s8,3.5888672,8,8S28.4111328,32,24,32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeMedium);
export default __webpack_public_path__ + "static/media/eye--medium.0d92760a4cc4951bd6be115a58450132.svg";
export { ForwardRef as ReactComponent };